import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ResendOtpCustomer } from '../../../api/authApi'; // Adjust path as needed

// State interface
interface ResendOtpState {
    loading: boolean;
    success: boolean;
    error: string | null;
    phone_number: string | null;
    message: string | null;
}

// Initial state
const initialState: ResendOtpState = {
    loading: false,
    success: false,
    error: null,
    phone_number: null,
    message: null,
};

// Async thunk for resend OTP
export const resendOtp = createAsyncThunk(
    'resendOtp',
    async (
        { phone_number }: { phone_number: string;},
        { rejectWithValue }
    ) => {
        try {
            const result = await ResendOtpCustomer(phone_number);

            if (!result.success) {
                return rejectWithValue(result.data);
            }

            return result.data;
        } catch (error) {
            return rejectWithValue({
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            });
        }
    }
);

// Slice
const resendOtpSlice = createSlice({
    name: 'resendOtp',
    initialState,
    reducers: {
        // Reset state
        resetResendOtp: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.phone_number = null;
            state.message = null;
        },
        // Clear error
        clearResendOtpError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Pending
            .addCase(resendOtp.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            // Fulfilled
            .addCase(resendOtp.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.success = true;
                state.error = null;
                state.phone_number = action.payload.phone_number || null;
                state.message = action.payload.message || 'OTP uğurla göndərildi';
            })
            // Rejected
            .addCase(resendOtp.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.success = false;

                // Handle different error types
                if (action.payload?.errors && Array.isArray(action.payload.errors)) {
                    // Validation errors
                    state.error = action.payload.errors[0]?.detail || 'Xəta baş verdi';
                } else if (action.payload?.error) {
                    // Generic error
                    state.error = action.payload.error;
                } else {
                    state.error = 'Bilinməyən xəta baş verdi';
                }
            });
    },
});

// Export actions
export const { resetResendOtp, clearResendOtpError } = resendOtpSlice.actions;

// Export reducer
export default resendOtpSlice.reducer;